var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
import Label from '../Label/Label';
import Box from '../../Layout/Flex/Box';
const HiddenRadioStyle = styled.input.attrs({ type: 'radio' }) `
    position: absolute;
    opacity: 0;
    height: ${props => props.theme.utils.getSize(props.radioSize)};
    width: ${props => props.theme.utils.getSize(props.radioSize)};
    &:focus + span {
        box-shadow: 0 0 0 0.05em #fff, 0 0 0.15em 0.1em ${props => props.color && props.theme.utils.getColor(props.color)};
      }
    &:checked + span::before {
        transform: scale(0.8);
      }
    & + span::before {
        display:block;
        content: "";
        height: ${props => props.theme.utils.getSize(props.radioSize)};
        width: ${props => props.theme.utils.getSize(props.radioSize)};
        box-shadow: inset 2rem 2rem ${props => props.color && props.theme.utils.getColor(props.color)};
        border-radius: 50%;
        transition: 180ms transform ease-in-out;
        transform: scale(0);    
      }
      
`;
const RadioStyle = styled.span `
    display: block;
    border-radius: 50%;
    margin-right: 4px;
    border: 0.1em solid ${props => props.color ? props.theme.utils.getColor(props.color) : '#EB3300'};
    height: ${props => props.theme.utils.getSize(props.radioSize)};
    width: ${props => props.theme.utils.getSize(props.radioSize)};
    ${props => props.mediaQuery}
`;
const Radio = (_a) => {
    var { isChecked, mediaQuery, labelMediaQuery, register, name, radioSize = 'note', label = '', isLoading = false, isLoadingLabel = false, labelSize = 'subArticle', labelColor = 'main', excludeMeFromLoadingContext = false, color = 'main', skeleton } = _a, props = __rest(_a, ["isChecked", "mediaQuery", "labelMediaQuery", "register", "name", "radioSize", "label", "isLoading", "isLoadingLabel", "labelSize", "labelColor", "excludeMeFromLoadingContext", "color", "skeleton"]);
    const { loadingContext } = useCronoSkeleton();
    return (_jsxs(Box, Object.assign({ alignItems: "center" }, { children: [_jsx(HiddenRadioStyle, Object.assign({ checked: isChecked, ref: register, name: name, radioSize: radioSize, color: color }, props)), (loadingContext && excludeMeFromLoadingContext === false) || isLoading
                ? _jsx(Skeleton, Object.assign({ width: "16px" }, skeleton, { style: { borderRadius: '50%' } }))
                : _jsx(RadioStyle, { className: "radio_control", color: color, radioSize: radioSize, mediaQuery: mediaQuery }), label &&
                _jsx(Label, { isLoading: isLoadingLabel && ((loadingContext && excludeMeFromLoadingContext === false) || isLoading), skeleton: { margin: 'h', width: '30px', style: { top: '2px' } }, label: label, labelSize: labelSize, color: labelColor || color, noMargin: true, mediaQuery: labelMediaQuery })] })));
};
export default Radio;
